import { render, staticRenderFns } from "./Import-colaborador.vue?vue&type=template&id=5c656fb8&scoped=true&"
import script from "./Import-colaborador.vue?vue&type=script&lang=js&"
export * from "./Import-colaborador.vue?vue&type=script&lang=js&"
import style0 from "./Import-colaborador.vue?vue&type=style&index=0&id=5c656fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c656fb8",
  null
  
)

export default component.exports